// Constants
const BANNER_TYPES = {
	success: "success",
	error: "error",
	pass: "pass",
	info: "info",
};
const BANNER_TRANSITION_SPEED = 200;
const ONE_FRAME = 16;

const DEFAULT_OPTIONS = {
	message: "",
	timeout: 0,
	type: BANNER_TYPES.success,
};

// Private variables
let closeTimeout = null;
let bannerEl = null;
let contentEl = null;

// Public interface
const FeedbackBanner = {
	options: {},

	init() {
		// This little no-op exists because at one time the old coffeescript version
		// of this library had a fire-and-forget init function, and I don't want to
		// cause a bunch of errors by not having it.
	},

	/**
	 * Open a new feedback banner
	 * @param {object} args - A dictionary of options for the banner.
	 * @param {string} args.message - A message to display in the banner.
	 * @param {int} args.timeout - Time, in milliseconds, to show the banner.
	     Defaults to 0, leaving the banner open until you call close().
	 * @param {string} args.type - Type of banner, 'success' or 'error'.
	 * @param {function} args.onClose - A function to trigger when closed.
	 *
	 * @returns {object} itself
	 */
	open(args = {}) {
		// Clear old timeout
		clearTimeout(closeTimeout);

		// Set options, merging in defaults
		this.options = {
			...DEFAULT_OPTIONS,
			...args,
		};

		// Only allow whitelisted types
		if (args.type && !BANNER_TYPES[args.type]) {
			console.warn(`
				Unknown type '${args.type}' supplied to FeedbackBanner.
				Defaulting to '${DEFAULT_OPTIONS.type}'.
			`);
			this.options.type = DEFAULT_OPTIONS.type;
		}

		// If it's currently open, close and try again. Otherwise, fire it up!
		if (this.showing) {
			this.close();
			setTimeout(() => {
				this.open(this.options);
			}, BANNER_TRANSITION_SPEED + ONE_FRAME);
		} else {
			this.create();
		}

		return this;
	},

	/**
	 * Creates the banner element, adds it to the document.
	 * @returns {object} itself
	 */
	create() {
		this.showing = true;

		bannerEl = document.createElement("div");
		bannerEl.id = "feedback_banner";
		bannerEl.className = this.options.type;

		contentEl = document.createElement("div");
		contentEl.className = "inner";
		contentEl.innerHTML = this.options.message;

		bannerEl.appendChild(contentEl);
		document.body.appendChild(bannerEl);

		setTimeout(() => {
			if (bannerEl && !this.closing) {
				bannerEl.className += " show";
			}
		}, ONE_FRAME);

		if (this.options.timeout) {
			closeTimeout = setTimeout(() => {
				this.close();
			}, this.options.timeout + ONE_FRAME);
		}

		return this;
	},

	/**
	 * Closes the banner, no-op if it's not open.
	 */
	close() {
		this.closing = true;
		clearTimeout(closeTimeout);

		if (this.options.onClose) {
			this.options.onClose();
		}

		if (bannerEl) {
			bannerEl.className = bannerEl.className.replace("show", "");
		}

		setTimeout(() => {
			this.closing = false;
			this.showing = false;

			if (typeof (bannerEl) !== "undefined" && bannerEl !== null) {
				if (typeof (bannerEl.remove) === "function") {
					bannerEl.remove();
				}

				bannerEl = null;
				contentEl = null;
			}
		}, BANNER_TRANSITION_SPEED);
	},
};

export default FeedbackBanner;



// WEBPACK FOOTER //
// ./src/shared/util/FeedbackBanner.js